module.exports = __webpack_public_path__ + "media/images/WFC_Award_White-7f21ca4a456255eca2f3c5a46ea321eb.svg";